export enum DateFormats {
  MM_DD_YYYY = "MM/DD/YYYY",
  MM_DD_YYYY_h_mm_a = "MM/DD/YYYY h:mm a",
  MM_DD_YYYY_hh_mm_ss_a = "MM/DD/YYYY hh:mm:ss a",
  MM_DD_YYYY_comma_hh_mm_ss_a = "MM/DD/YYYY, hh:mm:ss a",
  TIME_AM_PM = "hh:mm a",
  YYYY_MM_DD = "YYYY-MM-DD",
  YYYYMMDD = "YYYYMMDD",
  TIME_HH_MM_SS = "hh:mm:ss",
  DD_MM_YYYY = "DD/MM/YYYY",
  DDMMYYYY = "DD-MM-YYYY",
  YYYY_MM_DDTHH_mm_ss = "YYYY-MM-DDTHH:mm:ss"
}

const receivedDateTime = "receivedDateTime";
const dateTimeReceived = "dateTimeReceived";

export const FieldType = {
  receivedDateTime,
  dateTimeReceived
};

export const ValidYear = 1900;